import { Stack, TableCell, TableRow } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ExpiredChip from "../../../../components/display/ExpiredChip";
import Status from "../../../../components/Status";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import {
  PENDING_APPOINTEMENT_DETAILS,
  SINGLE_RESERVATION_ADMINISTRATION_DETAILS,
} from "../../../../enums/UrlPaths";
import useUser from "../../../../hooks/useUser";
import { trimText } from "../../../../utils/Functions";
import { getStatusOrder } from "./DesktopReservations";

export default function AppointmentTableRow({ data, index }) {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const lang = i18n.language;
  const [service, setService] = React.useState("priceList.title");
  const { roles } = useUser();
  const { mode } = React.useContext(ThemeContext);
  const bgColorOfRow = mode == "dark" ? "black" : "#f5f3f4";
  const [searchParams] = useSearchParams();
  const location = useLocation();
  
  React.useEffect(() => {
    const currentLangName = data?.priceList?.translations[lang];
    if (currentLangName != null && currentLangName != "") {
      setService(`priceList.translations.${lang}`);
    } else {
      setService("priceList.title");
    }
  }, [lang, data]);

  const handleClick = (e, id, status) => {
    const currentFilters = Object.fromEntries(searchParams.entries());
    if (roles.adminOrEmployee && status == 1) {
      navigate(PENDING_APPOINTEMENT_DETAILS + id, {
        state: {
          filters: currentFilters,
          from: location.pathname
        },
      });
    } else {
      navigate(SINGLE_RESERVATION_ADMINISTRATION_DETAILS + id, {
        state: {
          filters: currentFilters,
          from: location.pathname
        },
      });
    }
  };

  function getStatusSymbol(value, field) {
    if (field === "status") {
      const val = getStatusOrder(value);
      //If is past
      if (val == 3) {
        return <ExpiredChip show />;
      }
      return (
        <Status
          status={val}
          testId={`appointment.admin-table.row.${value.id}.status-symbol`}
        />
      );
    }

    if (field === "startDate") {
      return (
        dayjs(value[field]).format("DD/MM/YYYY HH:mm") +
        " - " +
        dayjs(value["endDate"]).format("HH:mm")
      );
    }

    return trimText(value[field], 30);
  }

  const getNestedFieldValues = (object, path) => {
    const fields = path.split(".");
    let value = object;
    fields.forEach((field) => {
      if (value && value.hasOwnProperty(field)) {
        value = value[field];
      } else {
        value = undefined;
      }
    });

    if (!value) {
      return "N/A"
    }
    
    return trimText(value, 30);
  };

  return (
    <TableRow
      hover
      onClick={(event) => handleClick(event, data.id, data.status)}
      key={data.id}
      tabIndex={-1}
      sx={{
        cursor: "pointer",
        bgcolor: index % 2 == 0 ? bgColorOfRow : "none",
      }}
      data-testid={`appointment.admin-table.row.${data.id}`}
    >
      {[
        "status",
        "startDate",
        service,
        "ownerEmail",
        "phoneNumber",
        "petName",
      ].map((field) => (
        <TableCell key={field} align="center" sx={{ wordWrap: "break-word" }}>
          {field !== "status" ? (
            getNestedFieldValues(data, field)
          ) : (
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ width: "100%", height: "100%" }}
            >
              {getStatusSymbol(data, field)}
            </Stack>
          )}
        </TableCell>
      ))}
    </TableRow>
  );
}
